import { ValidatorFn, AsyncValidatorFn, AbstractControl } from '@angular/forms';
import { ControlValidatorPlugin, ControlConfigTuple } from '@controls/model/control-validator-plugin';
import { extendControlValidators, extendControlAsyncValidators } from '@controls/utils/control-validators-extender';

export abstract class AbstractControlValidatorPlugin<T> implements ControlValidatorPlugin<T> {
  abstract getValidators(config?: T): ValidatorFn[] | null;
  abstract getAsyncValidators(config?: T): AsyncValidatorFn[] | null;
  abstract getSymbol(config: T): symbol;

  connect(controlConfig: ControlConfigTuple<T>): void {
    const { control, config } = controlConfig;
    const __symbol = this.getSymbol(config);
    if (!control[__symbol]) {
      this.doConnect(control, config);
      control[__symbol] = true;
    }
  }

  protected doConnect(control: AbstractControl, config: T) {
    const validators = this.getValidators(config);
    if (validators != null) {
      extendControlValidators(control, validators);
    }
    const asyncValidators = this.getAsyncValidators(config);
    if (asyncValidators != null) {
      extendControlAsyncValidators(control, asyncValidators);
    }
  }

  disconnect({ control, config }: ControlConfigTuple<T>): void {
    control.clearValidators();
    control.clearAsyncValidators();
    delete control[this.getSymbol(config)];
  }
}
